import { Snackbar, styled } from '@mui/material'

export const Root = styled(Snackbar)`
  &.MuiSnackbar-root {
    font-family: ${props => props.theme.typography.fontFamily};
  }
`
